import * as Yup from 'yup'

const requiredFieldText = 'This field is required';

export const AddStreamlineAccountValidation = Yup.object().shape({
  token_key: Yup.string().required(requiredFieldText),
  token_secret: Yup.string().required(requiredFieldText),
  advertiserId: Yup.string().required(requiredFieldText),
  advertiser_name: Yup.string().required(requiredFieldText)
});
